import React from "react";
// import "./style/dataLog.css";
import { Table, Pagination } from "rsuite";
import { useEffect } from "react";
import { useState } from "react";
import { ThemeContext } from "../../../../context/ThemeContext";
import { useContext } from "react";

const { Column, HeaderCell, Cell } = Table;
// const defaultData = mockUsers(100);

const MonthlyFishLog = ({
  tableData,
  setActivePage,
  setDataView,
  activePage,
  totalDataCount,
  tableLoading,
 
}) => {
  const theme = useContext(ThemeContext);
  const [limit, setLimit] = React.useState(10);

  // const [page, setPage] = React.useState(4);
  const [totalData, setTotalData] = useState(totalDataCount);
  const [ loading,setLoading] = useState(true);

  const handleChangeLimit = (dataKey) => {
    setLimit(dataKey);
    setActivePage(1);
    setDataView(dataKey);
  };
  const setActivePageHandler = (dataKey) => {
    setActivePage(dataKey);
  };
  useEffect(() => {
    setTotalData(totalDataCount);
  }, [totalDataCount]);

 
  

  let data = [...tableData];
  const loadingHandler = () => {
    // return true;
    // return setTimeout(myGreeting, 100);
    // function myGreeting(){
    //   return true;
    // }
    return false;
  };

  return (
    <div className="theme-background theme-text">
      <Table
        // loading={tableData.length > 0 ? false : true}
        loading={tableLoading ? true : false}
        height={500}
        data={data}
        // renderEmpty={() => {
        //   return <div className="rs-table-body-info">No Data Available</div>;
        // }}
        // className={`${theme} `}
        // style={{ background: "red" }}
      >
        
        <Column
          width={100}
          className={`theme-text theme-table-background`}
          flexGrow={1}
        >
          <HeaderCell style={{ color: "#6C88AF" }}>Tank Name</HeaderCell>
          <Cell dataKey="tank_name" />
        </Column>
        <Column
          width={100}
          className={`theme-text theme-table-background`}
          flexGrow={1}
        >
          <HeaderCell style={{ color: "#6C88AF" }}>Fish Name</HeaderCell>
          <Cell dataKey="fish_name" />
        </Column>
        <Column
          width={100}
          className={`theme-text theme-table-background`}
          flexGrow={1}
        >
          <HeaderCell style={{ color: "#6C88AF" }}>Fish In</HeaderCell>
          <Cell dataKey="in_fish" />
        </Column>

        <Column
          width={100}
          className={`theme-text theme-table-background`}
          flexGrow={1}
        >
          <HeaderCell style={{ color: "#6C88AF" }}>Fish Out</HeaderCell>
          <Cell dataKey="out_fish" />
        </Column>

        <Column
          width={100}
          className={`theme-text theme-table-background`}
          flexGrow={1}
        >
          <HeaderCell style={{ color: "#6C88AF" }}>Mortality</HeaderCell>
          <Cell dataKey="mortality_fish" />
        </Column>
        <Column
          width={200}
          flexGrow={1}
          className={`theme-text theme-table-background`}
        >
          <HeaderCell style={{ color: "#6C88AF" }}>Total Fish</HeaderCell>
          <Cell dataKey="total_fish" />
        </Column>
        <Column
          width={200}
          flexGrow={1}
          className={`theme-text theme-table-background`}
        >
          <HeaderCell style={{ color: "#6C88AF" }}>Time</HeaderCell>
          <Cell dataKey="daily" />
        </Column>
      </Table>
      <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="lg"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={totalData}
          // total={10}
          limitOptions={[10, 30, 50, 100, 200]}
          limit={limit}
          // activePage={page}
          // onChangePage={setPage}
          activePage={activePage}
          onChangePage={setActivePageHandler}
          onChangeLimit={handleChangeLimit}
          // onChangePage={handlePageChange}
          className={`theme-text`}
        />
      </div>
      {/* <Pagination
        prev
        last
        next
        first
        size="lg"
        total={totalDataCount}
        limit={limit}
        maxButtons={5}
        activePage={activePage}
        onChangePage={setActivePage}
        boundaryLinks
      /> */}
    </div>
  );
};
export default MonthlyFishLog;
